import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=36502098&scoped=true&"
import script from "./UserPage.vue?vue&type=script&lang=ts&"
export * from "./UserPage.vue?vue&type=script&lang=ts&"
import style0 from "./UserPage.vue?vue&type=style&index=0&id=36502098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36502098",
  null
  
)

export default component.exports